import React from "react";

const Nosotros = () => {
  return (
    <div>
      {/* Hero Section with the curved bottom */}
      <div className="relative">
        <div
          className="bg-cover bg-center h-[500px] flex items-center justify-center text-white"
          style={{
            backgroundImage: "url('/images/nosotros/law+1+banner.png')",
          }}
        >
          <div className="text-center p-6 max-w-lg">
            <h1 className="text-2xl font-bold mb-2">
              "En cada desafío se esconde una oportunidad"
            </h1>
            <p className="mb-6">~ Albert Einstein</p>
            <button className="bg-white text-black px-4 py-2 rounded-full hover:bg-gray-200 transition">
              CONSULTA GRATIS
            </button>
          </div>
        </div>
        {/* Curved edge at the bottom */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 70"
            className="w-full"
            preserveAspectRatio="none"
            style={{ display: "block", marginBottom: "-1px" }}
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,70 L1440,70 L1440,0 C1200,30 960,45 720,45 C480,45 240,30 0,0 L0,70 Z"
            ></path>
          </svg>
        </div>
      </div>

      {/* Nosotros Section */}
      <div className="container mx-auto px-4 pt-0 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="flex flex-col justify-center h-full">
            <h2 className="text-2xl font-bold mb-6">NOSOTROS</h2>
            <div>
              <p>
                <span className="font-bold">T-DEFENDEMOS</span> es una firma de
                abogados que se centra en ofrecer una experiencia legal
                personalizada y efectiva, priorizando la comunicación, el
                compromiso, la integridad y la persistencia en la defensa y
                protección de los intereses jurídicos de nuestros clientes para
                brindarles la mayor satisfacción posible.
              </p>
            </div>
          </div>
          <div className="flex justify-center items-center">
            <div className="w-[500px] h-[500px] overflow-hidden rounded-lg">
              <img
                src="/images/nosotros/law+4.png"
                alt="Martillo de juez"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Misión Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="order-2 md:order-1 flex justify-center items-center">
            <div className="w-[500px] h-[500px] overflow-hidden rounded-lg">
              <img
                src="/images/nosotros/law+7.png"
                alt="Estatua de la justicia"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
          <div className="order-1 md:order-2 flex flex-col justify-center h-full">
            <h2 className="text-2xl font-bold mb-6">MISIÓN</h2>
            <p>
              Nuestra misión es proporcionar servicios jurídicos de alta
              calidad, basados en los valores de comunicación efectiva,
              compromiso, integridad y persistencia, para la defensa y
              protección de los intereses legales de nuestros clientes en
              Cartagena, Colombia. Nos comprometemos a ofrecer una experiencia
              legal personalizada y centrada en el cliente, buscando soluciones
              pacíficas y prácticas para resolver conflictos legales en una
              variedad de áreas, desde asuntos penales y civiles hasta reclamos
              ante aseguradoras y acciones constitucionales. Nuestra dedicación
              a la excelencia y nuestra comprensión profunda de las necesidades
              de nuestra comunidad local nos guían en nuestra búsqueda de
              justicia y equidad para nuestros clientes.
            </p>
          </div>
        </div>
      </div>

      {/* Visión Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="flex flex-col justify-center h-full">
            <h2 className="text-2xl font-bold mb-6">VISIÓN</h2>
            <p>
              Primordialmente, prestamos de todo tipo de servicios jurídicos,
              como consultoría, asesoría y representación legal, pero también
              tenemos un enfoque complementario de marketing, en donde les
              proporcionamos negocios a abogados y firmas de abogados que tengan
              convenio vigente hasta obtener un modelo de gestión jurídica que
              nos permita ser la fuente de internet primaria en la búsqueda de
              datos sobre representación legal para de esa manera, escoger
              nuestros casos y los que no, los referiremos a firmas que busquen
              la adquisición de casos en escalas masivas por la dimensión del
              talento humano que la opera.
            </p>
          </div>
          <div className="flex justify-center items-center">
            <div className="w-[500px] h-[500px] overflow-hidden rounded-lg">
              <img
                src="/images/nosotros/4.png"
                alt="Libros de derecho"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nosotros;
